import { combineReducers } from 'redux';
import { cart } from './Columbus/Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from "./Reducers/FacetedSearch.reducer";
import { myPage } from './Columbus/Reducers/MyPage.reducer';
import { checkout } from "./Columbus/Reducers/Checkout.reducer";
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { productInfoTab } from './Columbus/Reducers/ProductInfoTab.reducer';
import { selectOrganization } from './Columbus/Reducers/SelectOrganization.reducer';
import { newsletterSignup } from './Columbus/Reducers/NewsletterSignup.reducer';
import { genericExport } from './Columbus/Reducers/GenericExport.reducer';
import { exportMenu } from './Columbus/Reducers/ExportMenu.reducer';

const app = combineReducers({
    cart,
    checkout,
    quickSearch,
    navigation,
    myPage,
    facetedSearch,
    lightboxImages,
    productInfoTab,
    selectOrganization,
    newsletterSignup,
    genericExport,
    exportMenu
});

export default app;